import styled from "styled-components";

export const TableHeader = styled.div`
  margin: 0 auto 10px;
  max-width: 860px;
  width: 100%;
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const HeaderSection = styled.div`
  padding-right: 2px;
  padding-left: ${({ paddingLeft }) => paddingLeft && paddingLeft};
  width: ${({ width }) => width && width};
  display: flex;
  justify-content: ${({ justifyRight }) => justifyRight && "flex-end"};
  position: relative;
`;
export const HeaderTitle = styled.p`
  padding: 2px 5px;
  font-size: 16px;
  font-weight: 500;
  color: #808080;
  border: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: #d8d8d8;
`;
export const FilterButton = styled.button`
  padding: 2px 5px;
  font-size: 16px;
  font-weight: 500;
  color: #808080;
  border: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: #d8d8d8;
  cursor: pointer;
`;
export const FilterText = styled.p`
  padding: 2px 0;
  font-size: 16px;
  font-weight: 500;
  color: #808080;
`;
export const FilterIndicatorImg = styled.img`
  margin-left: 5px;
  width: 15px;
  height: 15px;
`;
